import React from 'react';

/**
 * The AbTunes "4b" note glyph (reads as A♭) — the production brand vector
 * (public/images/logo/abtunes/abtunes-symbol-red.svg), inlined so the fill
 * follows context: #fa2d48 on dark surfaces, #C92032 on light.
 */
export const AbGlyph = ({size = 26, color = '#fa2d48'}) => (
    <svg width={size} height={size} viewBox="56 84 536 536" aria-hidden="true">
        <path
            fill={color}
            fillRule="evenodd"
            d="M335 111C348 111 359 122 359 135V324H379C460 324 520 373 520 448C520 526 447 580 342 591C324 594 311 582 311 568V372H151C131 372 120 349 133 333L316 121C321 114 328 111 335 111Z M311 196L201 324H311Z M359 372V539C429 526 472 491 472 448C472 399 437 372 379 372Z"
        />
    </svg>
);

/** Glyph + wordmark lockup. */
export const AbMark = ({size = 26, color = '#fa2d48', className = ''}) => (
    <span className={'inline-flex items-center gap-2 font-extrabold tracking-[-0.03em] ' + className}>
        <AbGlyph size={size} color={color}/>
        AbTunes
    </span>
);
